import React,{useState} from 'react'
import {FormControl} from 'react-bootstrap';

const SearchControl = ({onSearch}) => {

    const [showing, Showing] = useState(false)

    const onChange = (e) => {
        onSearch(e.target.value)
    }

    const onClick = (e) => {
        if(showing)
            onSearch("")
            
        Showing(!showing)
    }

    return (
        <>
                        
        <i className="fa fa-search" style={{ fontSize:'1.1rem', marginLeft:"1rem"}} onClick={onClick} ></i>

        { showing ?       
            <FormControl 
                className="d-inline" 
                style={{ textAlign: 'center', backgroundColor:'lightyellow', width:"5rem", fontSize:'1.2rem' }} 
                name="Search" type="text" 
                defaultValue=""
                onChange={onChange}
                placeholder="بحث" />
        : null }

        </>
    )
}

export default SearchControl
